import { state } from '@/components/MapGeneration/store/state';

import { ContoursSvg } from '../icons';
import { LAYER_SETTINGS_TYPES } from '../../constants';
import { ContourSettings } from './ContourSettings';

import type { LayerPattern } from '@/components/MapGeneration/layers/patterns';

export const contours: LayerPattern = {
    id: 'Contour',
    key: 'contour',
    title: 'Контуры',
    icon: ContoursSvg,
    widget: ContourSettings,
    settings: [],
    settingsInit: () => [
        {
            title: 'contour_settings',
            key: 'contour_settings',
            type: LAYER_SETTINGS_TYPES.CUSTOM,
            defaultValue: state.contourData.map(data => ({
                brush_color: data.brush_color,
                brush_visible: data.brush_visible,
                contour_id: data.contour_id,
                contour_type_id: data.contour_type_id,
                contour_name: data.contour_name,
                field_id: data.field_id,
                marker_visible: data.marker_visible,
                pen_color: data.pen_color,
                pen_visible: data.pen_visible,
                pen_width: data.pen_width,
                pen_style: data.pen_style,
                stratum_id: data.stratum_id,
                visible: data.visible,
            })),
            level: 0,
        },
        {
            title: 'private_contour_settings',
            key: 'private_contour_settings',
            type: LAYER_SETTINGS_TYPES.CUSTOM,
            defaultValue: state.contourData.map(data => ({
                field_id: data.field_id,
                field_visible: true,
                stratum_id: data.stratum_id,
                stratum_name: data.stratum_name,
                stratum_visible: true,
                contour_type_id: data.contour_type_id,
                contour_type_name: data.contour_type_name,
                contour_name: data.contour_name,
                contour_type_visible: true,
                contour_id: data.contour_id,
                contour_visible: data.visible,
            })),
            level: 0,
        },
        {
            title: 'shape_files_settings',
            key: 'shape_files_settings',
            type: LAYER_SETTINGS_TYPES.CUSTOM,
            defaultValue: [],
            level: 0,
        },
    ],
};
